import { announcementCvCandidateId } from '../utils/announcementManagement';
import { announcementCvFile } from '../utils/announcementCvFile';
export async function loadAnnouncementCv(api, candidate) {
  const id = announcementCvCandidateId(candidate);
  if (!id) throw new Error('La candidature n’est pas rattachée à une fiche candidat.');
  const read = async url => {
    try { return await api.get(url); }
    catch(error) {
      if(error.response?.status === 403) throw new Error("L’agence active n’a pas accès à ce candidat ou à son CV. Le partage de cette candidature entre agences doit être vérifié côté serveur.");
      throw error;
    }
  };
  const tryCv = async candidateId => {
    try {
      const {data}=await read(`cv/${encodeURIComponent(candidateId)}`);
      if(data?.data) return announcementCvFile(data);
    } catch(error) {
      if(error.response && ![404].includes(error.response.status)) throw error;
      if(!error.response) throw error;
    }
    return null;
  };
  const direct=await tryCv(id);
  if(direct)return direct;
  // Resolve a linked source using the exact candidate ID, never a name match.
  let profile;
  try { ({data:profile}=await read(`tempworker-candidate/${encodeURIComponent(id)}`)); }
  catch(error) {
    if(error.response?.status === 404) throw new Error("Cette fiche candidat est introuvable ou inaccessible depuis l’agence active. Cela ne permet pas de conclure que le CV est absent. Le rattachement à l’annonce doit être vérifié côté serveur.");
    throw error;
  }
  const source=announcementCvCandidateId(profile || {});
  if(source && String(source)!==String(id)) {
    const linked=await tryCv(source);
    if(linked)return linked;
  }
  const {data:documents}=await read(`document/candidate/${encodeURIComponent(source || id)}`);
  const cvs=(Array.isArray(documents)?documents:[]).filter(row=>/^(cv|curriculum vitae)$/i.test(String(row.type || '').trim())).sort((a,b)=>(Date.parse(b.createdAt)||0)-(Date.parse(a.createdAt)||0));
  if(cvs[0]?._id){const {data}=await read(`document/${encodeURIComponent(cvs[0]._id)}`);return announcementCvFile(data);}
  throw new Error('Aucun CV trouvé sur la fiche candidat, sa fiche source ou ses documents de type CV. Le fichier doit être ajouté ou son rattachement corrigé côté serveur.');
}
